export const LEAD_STATUSES = [
  "New", "Contacted", "Meeting Scheduled", "Requirement Received",
  "Proposal in Preparation", "Proposal Sent", "Follow-up",
  "Negotiation", "Won", "Lost", "On Hold",
];

export const LEAD_TERMINAL = ["Won", "Lost", "On Hold"];

export const LEAD_SOURCES = ["Referral", "Website", "Instagram", "LinkedIn", "Cold Call", "Existing Client", "Other"];
export const LEAD_SERVICES = ["Social Media", "Website", "App", "Performance Marketing", "Branding", "Other"];
export const LEAD_PRIORITIES = ["Low", "Medium", "High"];

export const LEAD_STATUS_COLORS = {
  "New": "bg-blue-500/15 border-blue-500/30 text-blue-700",
  "Contacted": "bg-cyan-500/15 border-cyan-500/30 text-cyan-700",
  "Meeting Scheduled": "bg-indigo-500/15 border-indigo-500/30 text-indigo-700",
  "Requirement Received": "bg-violet-500/15 border-violet-500/30 text-violet-700",
  "Proposal in Preparation": "bg-purple-500/15 border-purple-500/30 text-purple-700",
  "Proposal Sent": "bg-fuchsia-500/15 border-fuchsia-500/30 text-fuchsia-700",
  "Follow-up": "bg-orange-500/15 border-orange-500/30 text-orange-700",
  "Negotiation": "bg-amber-500/15 border-amber-500/30 text-amber-700",
  "Won": "bg-emerald-500/15 border-emerald-500/30 text-emerald-700",
  "Lost": "bg-rose-500/15 border-rose-500/30 text-rose-700",
  "On Hold": "bg-neutral-500/15 border-neutral-500/30 text-neutral-800",
};

export const LEAD_PRIORITY_COLORS = {
  "Low": "bg-neutral-100 border-neutral-300 text-neutral-700",
  "Medium": "bg-blue-500/15 border-blue-500/30 text-blue-700",
  "High": "bg-rose-500/15 border-rose-500/30 text-rose-700",
};

export function followupBucket(dateStr, status) {
  if (LEAD_TERMINAL.includes(status)) return "done";
  if (!dateStr) return "none";
  const now = new Date(); now.setHours(0,0,0,0);
  const t = new Date(dateStr); t.setHours(0,0,0,0);
  const diff = Math.round((t - now) / 86400000);
  if (diff < 0) return "overdue";
  if (diff === 0) return "today";
  if (diff <= 7) return "week";
  return "later";
}
